import ApiService from '@/core/api/api.service';
import interceptor from '@/core/api/authInterceptor';
import axios from 'axios';

const headers = {
  Accept: 'application/json',
  Authorization: localStorage.getItem(process.env.VUE_APP_TOKEN_NAME),
};

const api = () => axios.create({
  baseURL: 'https://uzair-api.property-ai.co.uk',
  headers,
});


export class UzairCoreApiService extends ApiService {
  __setApi() {
    this.api = api();
    this.api.interceptors.response.use(undefined, interceptor(this.api));
  }

  stream(body = {}) {
    return this.request({
      method: 'post',
      data: this.payload,
      params: this.params,
      responseType: 'stream',
      adapter: 'fetch',
      ...body,
    });
  }
}
